// База данных продуктов AIVinity
// Структура: Направление → Категория → Продукт

export interface Product {
  id: string
  title: string
  description: string
  price?: string
  duration?: string
  level?: string
}

export interface Category {
  id: string
  title: string
  description: string
  icon: string
  products: Product[]
}

export interface Direction {
  id: string
  title: string
  description: string
  tagline: string
  color: string
  categories: Category[]
}

export const directionsData: Direction[] = [
  {
    id: 'education',
    title: 'Образование',
    description: 'Обучающие материалы по работе с нейросетями и AI',
    tagline: 'Станьте экспертом',
    color: '#3b82f6',
    categories: [
      {
        id: 'videos',
        title: 'Обучающие видео',
        description: 'Видеоуроки по работе с нейросетями',
        icon: 'play-circle',
        products: [
          {
            id: 'video-1',
            title: 'ChatGPT для начинающих',
            description: 'Полное руководство по использованию ChatGPT в работе',
            duration: '2 часа 15 мин',
            level: 'Начальный'
          },
          {
            id: 'video-2',
            title: 'Midjourney: создание изображений',
            description: 'Генерация профессиональных изображений с помощью AI',
            duration: '1 час 45 мин',
            level: 'Средний'
          },
          {
            id: 'video-3',
            title: 'Prompt-инженерия',
            description: 'Искусство написания эффективных промптов для AI',
            duration: '3 часа',
            level: 'Продвинутый'
          },
          {
            id: 'video-4',
            title: 'AI в маркетинге',
            description: 'Автоматизация маркетинговых процессов с помощью AI',
            duration: '2 часа 30 мин',
            level: 'Средний'
          },
          {
            id: 'video-5',
            title: 'Комплексный AI-workflow',
            description: 'Построение полного цикла работы с нейросетями',
            duration: '4 часа',
            level: 'Продвинутый'
          }
        ]
      },
      {
        id: 'courses',
        title: 'Онлайн-курсы',
        description: 'Структурированные программы обучения',
        icon: 'book-open',
        products: [
          {
            id: 'course-1',
            title: 'AI-специалист',
            description: 'Комплексная программа обучения работе с AI-инструментами',
            duration: '3 месяца',
            price: '29 990 ₽'
          },
          {
            id: 'course-2',
            title: 'Нейросети в бизнесе',
            description: 'Практическое применение AI для автоматизации бизнеса',
            duration: '6 недель',
            price: '19 990 ₽'
          },
          {
            id: 'course-3',
            title: 'AI для контент-мейкеров',
            description: 'Создание контента с помощью нейросетей',
            duration: '4 недели',
            price: '14 990 ₽'
          }
        ]
      },
      {
        id: 'premium',
        title: 'Подписка Premium',
        description: 'Безлимитный доступ ко всем материалам',
        icon: 'star',
        products: [
          {
            id: 'premium-month',
            title: 'Premium на месяц',
            description: 'Доступ ко всем курсам, видео и чату с экспертами',
            price: '4 990 ₽/мес'
          },
          {
            id: 'premium-year',
            title: 'Premium на год',
            description: 'Годовая подписка со скидкой 40%',
            price: '35 990 ₽/год'
          }
        ]
      },
      {
        id: 'chat',
        title: 'Доступ в чат',
        description: 'Закрытое комьюнити экспертов',
        icon: 'message-circle',
        products: [
          {
            id: 'chat-basic',
            title: 'Базовый чат',
            description: 'Общение с другими студентами',
            price: '990 ₽/мес'
          },
          {
            id: 'chat-pro',
            title: 'PRO чат',
            description: 'Доступ к экспертам и приватным каналам',
            price: '2 990 ₽/мес'
          },
          {
            id: 'chat-vip',
            title: 'VIP чат',
            description: 'Личные консультации с основателями',
            price: '9 990 ₽/мес'
          }
        ]
      }
    ]
  },
  {
    id: 'it',
    title: 'IT-разработка',
    description: 'Готовые решения и разработка на заказ',
    tagline: 'Технологии будущего',
    color: '#9333ea',
    categories: [
      {
        id: 'ready-products',
        title: 'Готовые IT-продукты',
        description: 'Решения ready-to-use',
        icon: 'package',
        products: [
          {
            id: 'crm-system',
            title: 'CRM-система',
            description: 'Готовая CRM для малого бизнеса',
            price: 'от 49 990 ₽'
          },
          {
            id: 'landing-constructor',
            title: 'Конструктор лендингов',
            description: 'No-code платформа для создания посадочных страниц',
            price: 'от 9 990 ₽'
          },
          {
            id: 'analytics-dashboard',
            title: 'Дашборд аналитики',
            description: 'Визуализация бизнес-метрик в реальном времени',
            price: 'от 29 990 ₽'
          }
        ]
      },
      {
        id: 'custom-dev',
        title: 'Разработка на заказ',
        description: 'Индивидуальные решения под ваши задачи',
        icon: 'code',
        products: [
          {
            id: 'web-app',
            title: 'Web-приложение',
            description: 'Разработка веб-приложений любой сложности',
            price: 'от 150 000 ₽'
          },
          {
            id: 'mobile-app',
            title: 'Мобильное приложение',
            description: 'iOS и Android разработка',
            price: 'от 250 000 ₽'
          },
          {
            id: 'integration',
            title: 'Интеграция систем',
            description: 'Интеграция с внешними сервисами и API',
            price: 'от 80 000 ₽'
          }
        ]
      },
      {
        id: 'telegram-bots',
        title: 'Telegram-боты',
        description: 'Автоматизация бизнеса через Telegram',
        icon: 'bot',
        products: [
          {
            id: 'bot-basic',
            title: 'Простой бот',
            description: 'Базовый функционал: меню, FAQ, уведомления',
            price: 'от 15 000 ₽'
          },
          {
            id: 'bot-shop',
            title: 'Бот-магазин',
            description: 'Прием заказов и оплата через Telegram',
            price: 'от 45 000 ₽'
          },
          {
            id: 'bot-ai',
            title: 'AI-бот',
            description: 'Бот с интеграцией ChatGPT',
            price: 'от 70 000 ₽'
          },
          {
            id: 'bot-miniapp',
            title: 'Telegram Mini App',
            description: 'Полноценное веб-приложение внутри Telegram',
            price: 'от 120 000 ₽'
          }
        ]
      },
      {
        id: 'web-apps',
        title: 'Web-приложения',
        description: 'SPA и PWA разработка',
        icon: 'globe',
        products: [
          {
            id: 'admin-panel',
            title: 'Админ-панель',
            description: 'Панель управления для вашего сервиса',
            price: 'от 90 000 ₽'
          },
          {
            id: 'marketplace',
            title: 'Маркетплейс',
            description: 'Платформа для продажи товаров/услуг',
            price: 'от 300 000 ₽'
          },
          {
            id: 'saas-platform',
            title: 'SaaS платформа',
            description: 'Облачный сервис с подписками',
            price: 'от 500 000 ₽'
          }
        ]
      }
    ]
  },
  {
    id: 'robotics',
    title: 'Робототехника',
    description: 'Проекты и решения в области робототехники',
    tagline: 'Инновации в действии',
    color: '#22c55e',
    categories: [
      {
        id: 'kits',
        title: 'Учебные наборы',
        description: 'Конструкторы для обучения',
        icon: 'box',
        products: [
          {
            id: 'kit-starter',
            title: 'Стартовый набор',
            description: 'Базовый набор для знакомства с робототехникой',
            price: '12 990 ₽',
            level: 'Начальный'
          },
          {
            id: 'kit-advanced',
            title: 'Продвинутый набор',
            description: 'Набор с датчиками и моторами',
            price: '24 990 ₽',
            level: 'Средний'
          },
          {
            id: 'kit-pro',
            title: 'Профессиональный набор',
            description: 'Полный набор для создания сложных роботов',
            price: '49 990 ₽',
            level: 'Продвинутый'
          }
        ]
      },
      {
        id: 'design',
        title: 'Проектирование',
        description: 'Разработка робототехнических решений',
        icon: 'settings',
        products: [
          {
            id: 'design-consult',
            title: 'Консультация',
            description: 'Оценка технической реализуемости проекта',
            price: 'от 15 000 ₽'
          },
          {
            id: 'design-proto',
            title: 'Прототипирование',
            description: 'Создание работающего прототипа',
            price: 'от 80 000 ₽'
          },
          {
            id: 'design-prod',
            title: 'Производство',
            description: 'Запуск в серийное производство',
            price: 'от 300 000 ₽'
          }
        ]
      },
      {
        id: 'consulting',
        title: 'Консультации',
        description: 'Экспертная помощь',
        icon: 'user-check',
        products: [
          {
            id: 'consult-online',
            title: 'Онлайн-консультация',
            description: 'Видеозвонок с экспертом (1 час)',
            price: '5 000 ₽'
          },
          {
            id: 'consult-audit',
            title: 'Аудит проекта',
            description: 'Детальный анализ вашего проекта',
            price: 'от 25 000 ₽'
          }
        ]
      },
      {
        id: 'training',
        title: 'Обучение',
        description: 'Курсы по робототехнике',
        icon: 'graduation-cap',
        products: [
          {
            id: 'train-kids',
            title: 'Курс для детей',
            description: 'Робототехника для школьников 7-14 лет',
            duration: '2 месяца',
            price: '18 990 ₽'
          },
          {
            id: 'train-teens',
            title: 'Курс для подростков',
            description: 'Программирование роботов 14-18 лет',
            duration: '3 месяца',
            price: '24 990 ₽'
          },
          {
            id: 'train-adult',
            title: 'Курс для взрослых',
            description: 'Профессиональная робототехника',
            duration: '4 месяца',
            price: '39 990 ₽'
          }
        ]
      }
    ]
  }
]
